module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.c4bab49e.svg";